import {SendToEnterpriseModalPros} from './types';
import Modal from "../../../ui-components/Modal";
import Button from "../../../ui-components/Button";
import {FormattedMessage} from "react-intl";
import {useIntl} from "react-intl";

export const SendToEnterpriseModal = ({
  des_enterprise,
  onConfirm,
  onDismiss,
  sending,
  baseDraftNumber
}: SendToEnterpriseModalPros) => {
  const intl = useIntl();
  return (
    // @ts-ignore
    <Modal onExit={onDismiss}>
      <div className="flex flex-col gap-8">
        <h1 className="text-2xl font-extrabold">
          <FormattedMessage id="send_to_enterprise" defaultMessage="Invia all'impresa"/>
        </h1>
        <p>
          <FormattedMessage
            id="send_to_enterprise_alert"
            defaultMessage={`La bozza finale {baseDraftNumber} verrà inviata all'impresa: {enterprise}. Sei sicuro di voler procedere?`}
            values={
              {
                enterprise:<span className="font-semibold">
                  {des_enterprise}
                </span>,
                baseDraftNumber:<span className="font-semibold">
                  #{baseDraftNumber}
                </span>
              }
            }
          />
        </p>
        <div className="w-full">
          <Button
            full
            onClick={onConfirm}
            submitting={sending}
          >
            <FormattedMessage id="confirm"/>
          </Button>
        </div>
      </div>
    </Modal>
  )
}
